import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {CookieService} from "ngx-cookie-service";

@Injectable()
export class Interceptor implements HttpInterceptor {
  constructor(private cookies: CookieService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const isApiRequest = request.url.startsWith("https://api.cubedcon.com")
      || request.url.startsWith("https://connect.cubedcon.com")
      || request.url.startsWith("https://api-staging.cubedcon.com");

    // Do NOT attach Authorization from the session cookie.
    // Reason: Some backends expect a raw JWT if provided via header (no "Bearer " prefix),
    // while others require a static API bearer token. We let explicit headers (from APIService)
    // pass through unmodified and otherwise rely on withCredentials for cookie-based auth.

    // Keep sending cookies to API hosts (session required by many endpoints)
    if (isApiRequest) {
      request = request.clone({ withCredentials: true });
    }

    return next.handle(request);
  }
}
